<template>
  <textInput :name="name"
             :required="required"
             :label="label"
             :placeholder="placeholder"
             :value="value"
             :read-only="readOnly"
             :max-length="maxLength"
             :type="type"
             @input="onInputText"
  />
</template>

<script>
import customInputMixin from '@/components/frontoffice/form/customInput/mixin'
import textInput from '@/components/frontoffice/form/baseInput/text'

export default {
  components: {
    textInput
  },
  mixins: [customInputMixin],
  props: {
    value: {
      type: String
    },
    maxLength: {
      type: Number,
      default: 999
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  methods: {
    onInputText (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
